import { PermissionConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case PermissionConstant.SET_PERMISSIONS:
      return { ...state, list: payload };
    default:
      return state;
  }
};
